import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/violationActions'
import moment from 'moment'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Upload,
  Icon,
  DatePicker,
  message,
  Tooltip,
  Select
} from 'antd'
import { filterCaseInsensitive } from '../../../util'
import _ from 'lodash'

import config from '../../../config'
const { API_BASE } = config

const FormItem = Form.Item
const Option = Select.Option
const { TextArea } = Input
const propTypes = {}

class Violations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      content: null,
      fileList: [],
      attachmentToDelete: null,
      attachmentDetailsVisible: false
    }

    this.props.violationsRefresh({
      jobId: this.props.jobId
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.violationActions.violations !== prevProps.violationActions.violations
    ) {
      const highlightEntity = _.filter(
        this.props.violationActions.violations.data,
        entity => entity.id === parseInt(this.props.shortcutItemId, 10)
      )
      this.handleRowClick(highlightEntity[0])
      this.props.clearHighlight()
    }
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.props.getViolationsAttachments({
      violationId: row.id
    })
    this.setState({
      attachmentDetailsVisible: false,
      modalVisible: true,
      currentId: row.id,
      content: row
    })
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_violation')

    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('violationId', this.state.currentId)

    this.props.uploadAttachment({
      formData: formData,
      violationId: this.state.currentId
    })

    message.warning('Uploading file(s)...')
  }

  handleAddButton = () => {
    this.props.getViolationsAttachments({
      violationId: 0
    })
    this.setState({
      modalVisible: true,
      currentId: 0,
      content: null
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      Object.keys(values).forEach(function(key, value) {
        if (key === 'due_date') {
          if (moment(values[key]).isValid()) {
            values[key] = values[key].format('YYYY-MM-DD hh:mm:ss')
          } else {
            values[key] = null
          }
        }
      })

      const formData = new FormData()
      formData.append('jobId', this.props.jobId)
      formData.append('created_by_id', this.props.authentication.user.userId)
      formData.append('updated_by_id', this.props.authentication.user.userId)
      formData.append('name', values['name'])
      formData.append('description', values['description'])
      formData.append('due_date', values['due_date'])

      if (this.state.currentId === 0) {
        this.props.createViolation({
          formData: formData,
          jobId: this.props.jobId
        })
        message.success('Violation created!')
      } else {
        this.props.updateViolation({
          jobId: this.props.jobId,
          violationId: this.state.currentId,
          content: values,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      this.setState({ content: null, currentId: 0, modalVisible: false })
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      violationId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  onChangeAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      violationId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteViolation({
      jobId: this.props.jobId,
      violationId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      content: null,
      currentId: 0,
      modalVisible: false
    })
  }

  setStatus = status => {
    const payload = {
      status: status,
      updated_by_id: this.props.authentication.user.userId,
      updated_date: moment().format('YYYY/MM/DD HH:mm:ss')
    }
    this.props.setStatus({
      content: payload,
      violationId: this.state.currentId,
      jobId: this.props.jobId
    })
  }

  render() {
    const { content } = this.state

    const { getFieldDecorator } = this.props.form

    const props = {
      multiple: true,
      fileList: this.state.fileList
    }
    if (!this.props.violationActions.violations) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Violations"
          okText={content ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={content ? '90%' : '40%'}
          maskClosable={false}
        >
          <Form layout="vertical">
            {content && (
              <div className="row">
                <div className="col-9">
                  <h4>Violation #{content.id}</h4>
                </div>
                <div className="col-3 text-right">
                  <a href={`${API_BASE}/api/job/violations/${content.id}/print`} target="_blank">
                    <Button icon="printer">Print Violation</Button>
                  </a>
                </div>
              </div>
            )}
            {content && (
              <div className="row" style={{ marginBottom: '20px' }}>
                <div className="col-3">
                  Created Date:<br />
                  <strong>{moment(content.created_date).format('M/D/YYYY')}</strong>
                </div>
                <div className="col-3">
                  Updated Date:<br />
                  <strong>{moment(content.updated_date).format('M/D/YYYY')}</strong>
                </div>
                <div className="col-3">
                  Created By:<br />
                  <strong>{`${content.created_by_first_name} ${
                    content.created_by_last_name ? content.created_by_last_name : ''
                  }`}</strong>
                </div>
                <div className="col-3">
                  Updated by:<br />
                  <strong>{`${content.updated_by_first_name} ${
                    content.updated_by_last_name ? content.updated_by_last_name : ''
                  }`}</strong>
                </div>
              </div>
            )}
            {content && (
              <FormItem label="Set Status">
                <div className="row">
                  <div className="col-md-12">
                    {getFieldDecorator('type', {
                      initialValue: content ? content.status : ''
                    })(
                      <Select placeholder="Choose the status" onChange={this.setStatus}>
                        <Option value="With Team">With Team</Option>
                        <Option value="With Customer">With Customer</Option>
                        <Option value="With DOB">With DOB</Option>
                        <Option value="Closed">Closed</Option>
                      </Select>
                    )}
                  </div>
                </div>
              </FormItem>
            )}
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Name">
                  {getFieldDecorator('name', {
                    rules: [
                      {
                        required: true,
                        message: 'Must enter a name.'
                      }
                    ],
                    initialValue: content ? content.name : ''
                  })(<Input />)}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Due Date">
                  {getFieldDecorator('due_date', {
                    rules: [
                      {
                        required: true,
                        message: 'Must enter a due date.'
                      }
                    ],
                    initialValue: content ? moment(content.due_date) : ''
                  })(<DatePicker />)}
                </FormItem>
              </div>
            </div>
            <FormItem label="Description">
              {getFieldDecorator('description', {
                initialValue: content ? content.description : ''
              })(
                <TextArea
                  placeholder="Describe the attachment..."
                  rows={4}
                  initialvalue={content ? content.description : ''}
                />
              )}
            </FormItem>
            {this.props.violationActions.jobViolationAttachments &&
              this.props.violationActions.jobViolationAttachments.data.length > 0 && (
                <ReactTable
                  defaultPageSize={5}
                  defaultFilterMethod={filterCaseInsensitive}
                  data={this.props.violationActions.jobViolationAttachments.data}
                  getTrProps={(state, rowInfo, column, instance) => ({
                    onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                  })}
                  columns={[
                    {
                      Header: 'Attached Files',
                      columns: [
                        {
                          Header: 'Filename',
                          id: 'filename',
                          accessor: 'filename',
                          Cell: d => (
                            <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>
                          )
                        },
                        {
                          Header: 'Description',
                          id: 'description',
                          accessor: 'description',
                          Cell: d => (
                            <Tooltip title={d.original.description}>
                              {d.original.description}
                            </Tooltip>
                          )
                        },
                        {
                          Header: 'Created By',
                          id: 'created_by',
                          accessor: d => `${d.created_by_first_name}  ${d.created_by_last_name}`,
                          Cell: d => {
                            const r = `${d.original.created_by_first_name}  ${
                              d.original.created_by_last_name
                            }`
                            return <Tooltip title={r}>{r}</Tooltip>
                          }
                        },
                        {
                          Header: 'Updated By',
                          id: 'updated_by',
                          accessor: d => `${d.updated_by_first_name}  ${d.updated_by_last_name}`,
                          Cell: d => {
                            const r = `${d.original.updated_by_first_name}  ${
                              d.original.updated_by_last_name
                            }`
                            return <Tooltip title={r}>{r}</Tooltip>
                          }
                        },
                        {
                          Cell: row => (
                            <Tooltip placement="left" title="Open this file on a new window">
                              <a target="_blank" href={row.original.signedUrl}>
                                <Icon type="export" className="fontSize20" />
                              </a>
                            </Tooltip>
                          ),
                          maxWidth: 35
                        }
                      ]
                    }
                  ]}
                  defaultSorted={[
                    {
                      id: 'id',
                      desc: true
                    }
                  ]}
                  className="-striped -highlight"
                />
              )}
            {this.state.attachmentDetailsVisible && (
              <div className="attachmentSubCommand">
                <div>
                  <strong>{this.state.attachmentName}</strong>
                </div>
                <div className="row">
                  <div className="col-md-10">
                    <TextArea
                      placeholder="Describe the attachment..."
                      rows={4}
                      onChange={this.onDescriptionChange}
                      value={this.state.attachmentDescription}
                    />
                    <br />
                    <br />
                    <Button onClick={this.onChangeAttachmentDescription}>
                      <Icon type="save" /> OK
                    </Button>
                  </div>
                  <div className="col-md-2 text-right">
                    <Popconfirm
                      title="Are you sure you want to delete this attachment?"
                      onConfirm={this.confirmAttachmentDelete}
                      okText="Yes"
                      cancelText="No"
                    >
                      {content && <Button type="danger" icon="delete" />}
                    </Popconfirm>
                  </div>
                </div>
              </div>
            )}
            <br />
            {content &&
              this.state.currentId !== 0 && (
                <div>
                  <div>Files</div>
                  <br />
                  <Upload
                    {...props}
                    name="file"
                    customRequest={this.uploadAttachment}
                    onChange={this.onUploadChange}
                  >
                    <Button>
                      <Icon type="upload" /> Upload
                    </Button>
                  </Upload>
                </div>
              )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {content && this.state.currentId !== 0 && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Violations
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Violation
            </div>
          </div>
        </div>
        {this.props.violationActions.violations && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: e => {
                if (column.Header !== undefined) {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={this.props.violationActions.violations.data}
            columns={[
              {
                columns: [
                  {
                    Header: '#',
                    id: 'id',
                    accessor: 'id',
                    Cell: d => <Tooltip title={d.original.id}>{d.original.id}</Tooltip>,
                    maxWidth: 80
                  },
                  {
                    Header: 'Name',
                    id: 'name',
                    accessor: 'name',
                    Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Due Date',
                    id: 'due_date',
                    accessor: d => moment(d.due_date).format('M/D/YYYY'),
                    maxWidth: 130
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 130
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY'),
                    maxWidth: 130
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ violationActions, authentication }, ownProps) => ({
  violationActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

Violations.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Violations)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/Violations.js